import React, { useEffect, useContext, useState } from "react";
import { Container, Col, Row } from "react-bootstrap";
// import { CartX } from "react-bootstrap-icons";
import { isMobile } from "react-device-detect";
import _ from "lodash";
import ApiBasket from "../../../core/api/api.basket";
import { useLocation, Link, useNavigate } from "react-router-dom";
import ContextApp from "../../../core/contexts/context.app";

import OrderItemShow from "./Component/OrderItemShow";
import SkeletonOrderItemShow from "../../components/SkeletonComponent/SkeletonOrderItemShow";
import { IconErrorCircle } from "../../../assets/icons";

function OrderList() {
  const ctx = useContext(ContextApp);
  let location = useLocation();
  const { statusList, title } = location?.state || {};
  let navigate = useNavigate();
  const [basketList, setBasketList] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  var list = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // useEffect(() => {
  //     (async () => {
  //         try {
  //
  //             if (!_.isEmpty(location.state) && !_.isEmpty(location.state.statusList)) {
  //                 //دریافت  سبد های خرید
  //                 //https://localhost:9003/api/v1/Basket/GetAllBasketByStatus?StatusList=1&StatusList=0&StatusList=2&UserId=1&PageNumber=1&PageSize=1
  //                 let statusList = "";
  //                 location.state.statusList.forEach(element => {
  //                     statusList = statusList + "StatusList=" + element + "&";
  //                 });
  //                 statusList = statusList.substr(0, statusList.length - 1);
  //                 const result = await ApiBasket.getAllBasketByStatus();
  //
  //                 if (result.succeeded == true) {
  //                     setBasketList(result.data);
  //                 }
  //             }
  //             else {
  //                 navigate.push('/order', { prevPath: location.pathname });
  //             }
  //         } catch (error) {
  //
  //         } finally {
  //         }
  //     })();
  //     return () => { };
  // }, []);

  useEffect(() => {
    (async () => {
      try {
        if (ctx.isAuth && !_.isEmpty(ctx.userInfo)) {
          // درخواست لیست سفارشات براساس نوع سفارش
          const joinStatusList = statusList?.join(",");
          const result = await ApiBasket.getAllBasketByStatus({
            pageSize: 50,
            statusList: joinStatusList,
          });
          setIsLoading(false);

          if (result.succeeded == true) setBasketList(result.data);
        }
        // else {
        //     navigate.push('/login', { prevPath: location.pathname });
        // }
      } catch (error) {
      } finally {
      }
    })();
    return () => {};
  }, [ctx.isAuth, ctx.userInfo, location]);

  return (
    <Container
      fluid
      className={
        isMobile ? " main-content bg-light-3" : " main-content bg-light-3 "
      }
    >
      {!isMobile ? (
        <Container>
          <Row className="pt-3 pb-2 text-small">
            <Col xs={12} className="px-0">
              <Link to="/" className="text-muted">
                صفحه اصلی{" "}
              </Link>{" "}
              /
              <Link to="/profile" className="text-muted">
                {" "}
                پروفایل /
              </Link>
              <Link to="/order" className="text-muted">
                {" "}
                سفارش ها
              </Link>
              /
              <Link
                className="text-muted"
                to="/order/orderList"
                state={{ statusList, title }}
              >
                {title}
              </Link>
              {/* <Link to="/order/orderList" className="text-muted font-weight-bold">{location?.state?.title}</Link> */}
            </Col>
          </Row>
        </Container>
      ) : (
        // <Container>
        //     <Row>
        //         <Col xs={12}>
        //             <Row className="pb-2 pt-3">
        //                 <Col xs={12} className="my-auto pr-2 pl-0">
        //                     <Link to="/order" className="text-right text-dark">
        //                         <ArrowRightShort size={25} />
        //                         <h3 className="my-auto d-inline-block">{(location?.state?.title !== "همه سفارشها" ? " سفارش های " : "") + location?.state?.title}</h3>
        //                     </Link>

        //                 </Col>
        //             </Row>
        //         </Col>
        //     </Row>
        // </Container>
        <></>
      )}
      <Container className="min-height-page">
        {isLoading ? (
          <Row className="d-flex">
            {list.map((item) => (
              <SkeletonOrderItemShow key={item.id} />
            ))}
          </Row>
        ) : (
          <Row className=" pt-xl-0 pt-md-0 transaction-box xl-svg">
            {basketList &&
            basketList.filter((items) => items.status === 1).length > 0 ? (
              basketList &&
              basketList
                .filter((items) => items.status === 1)
                .map((item, index) => <OrderItemShow key={index} item={item} />)
            ) : (
              <div className="text-center vh-100">
                <IconErrorCircle fillColor="#b1b1b1" />
                <div className="pb-4">هنوز سفارشی ثبت نشده است!</div>
              </div>
            )}
          </Row>
        )}
        {/* // -------------------------------------------------------- */}
        {/* // ------------------------------------------------------------------ */}

        {/* <Col xs={12} lg={4} key="123456" className="pt-1 mt-1 tab-border-bottom">
                    //         <Link to="/order/orderDetail" className="text-dark">
                    //             <Row className="px-1">
                    //                 <Card className="w-100 rounded-4">
                    //                     <Card.Body>
                    //                         <Row>
                    //                             <Col xs={7}>
                    //                                 <div>کد سفارش  123456</div>
                    //                                 <div className="text-small pt-1 opacity-5">1400/05/20</div>
                    //                             </Col>
                    //                             <Col xs={5} className="text-left text-danger">
                    //                                 <span className="font-weight-bold">250.000</span>
                    //                                 <span className="text-small"> تومان</span>
                    //                             </Col>
                    //                         </Row>
                    //                         <div className="pr-2 arrow-left">
                    //                             <div className="bg-light-blue text-center rounded-4 border pr-2 pl-1 text-small text-muted">
                    //                                 مشاهده {" "}
                    //                                 <ChevronLeft size={10} className="" />
                    //                             </div>
                    //                         </div>
                    //                         <div className="pt-3 mt-2 border-dashed-top">
                    //                             <div>
                    //                                 شاتل
                    //                                 <span className="text-muted px-2 opacity-5">|</span>
                    //                                 پاراسل
                    //                                 <span className="text-muted px-2 opacity-5">|</span>
                    //                                 جنگ شبانه شب های طلایی کیش
                    //                             </div>
                    //                         </div>
                    //                     </Card.Body>
                    //                 </Card>
                    //             </Row>
                    //         </Link>
                    //     </Col> */}
      </Container>
    </Container>
  );
}
export default OrderList;
